import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getEffectiveActivities } from '../../service/chat-service';

import ActivityShare from './activityShare';

import styles from './style.module.less';
import redPack from './images/redPack.png';
import close from './images/close.png';
import dialogBac from './images/dialogBac.png';
import tools from '../../utils/tools';

const propTypes = {
  productName: PropTypes.string,
  productImg: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
const defaultProps = {
  productName: '',
  productImg: '',
};

class index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      close: 'none',
      isActive: 'none',
      productId: null,
      amount: 0,
      // forwardId: null,
    };
  }

  componentDidMount() {
    const productId = tools.getQueryString('productId');
    this.setState({ productId }, () => {
      this.getEffectiveActivities();
      // 活动分享
      // this.initWxConfig()
      // this.getForwardId()
      // this.setSpread()
    });
  }

  getEffectiveActivities = async () => {
    const { productId } = this.state;
    try {
      const result = await getEffectiveActivities(productId);
      if (result) {
        if (result.status === 2) {
          this.setState({ isActive: 'block', amount: result.lastAmount });
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }

  openMask = () => {
    this.setState({ close: 'block' });
  }

  closeMask = () => {
    this.setState({ close: 'none' });
  }

  handleDetail = () => {
    const { productId } = this.state;
    const { productName, history } = this.props;
    const shareUserId = tools.getQueryString('shareUserId');
    const price = tools.getQueryString('price');
    history.push(
      `/rewardRule?productId=${productId}&shareUserId=${shareUserId}&price=${price}&productName=${productName}`,
    );
  }

  render() {
    const { productName, productImg } = this.props;
    const { amount, close: close1, isActive } = this.state;
    return (
      <div className={styles.containerBox}>
        <div
          style={{ display: isActive }}
          className={styles.redBox}
          onClick={this.openMask}
          role="button"
          tabIndex={0}
        >
          <img src={redPack} alt="" />
          <p>转发有奖</p>
        </div>
        <div className={styles.maskBox} style={{ display: close1 }}>
          <div className={styles.dialog} style={{ display: close1 }}>
            <div className={styles.bacImage} style={{ background: `url(${dialogBac}) no-repeat center center` }}>
              <img
                className={styles.redBacClose}
                src={close}
                onClick={this.closeMask}
                alt=""
                role="presentation"
                label="close"
              />
              <div className={styles.redInfo}>微信余额秒到账</div>
              <div className={styles.redAmount}>转发此链接</div>
              <div className={styles.redAmount} style={{ top: '51%' }}>
                最高领
                {amount / 100}
                元
              </div>
              <div
                className={styles.redButton}
                onClick={this.handleDetail.bind(this)}
                role="button"
                tabIndex={0}
              >
                查看详情
              </div>
            </div>
          </div>
        </div>
        <ActivityShare productImg={productImg} productName={productName} />
      </div>
    );
  }
}

index.propTypes = propTypes;
index.defaultProps = defaultProps;

export default withRouter(index);
